import React from "react";
import pic1 from "../assets/images/engineer-4941342_1280.jpg";
import pic2 from "../assets/images/industry-3196696_1280.jpg";
import pic3 from "../assets/images/istockphoto-1351834734-1024x1024.jpg";
import pic4 from "../assets/images/s.jpg";
import pic5 from "../assets/images/controol1024x1024.jpg";

const categoryContents = [
  [
    {
      image: pic1,
      isOffSection: false,
      name: "Assets",
    },
    {
      image: pic2,
      isOffSection: false,
      name: "Project",
    },
  ],

  [
    {
      image: pic3,
      isOffSection: false,
      name: "power",
    },
    {
      image: pic4,
      isOffSection: false,
      name: "Management",
    },
  ],
  [
    {
      image: pic5,
      isOffSection: false,
      name: "market",
    },
    {
      image: "",
      isOffSection: true,
    },
  ],
];

const Services = () => {
  const handleButtonClick = (image) => {
    console.log(`Button clicked for ${image}`);
  };

  return (
    <div>
      <section class="flex flex-col my-8 space-y-4">
        <h1 class="text-2xl text-[#7a3432] font-semibold drop-shadow-lg mb-4 ">
          Our Services
        </h1>
        <p class="text-gray-900 text-md">
          We have successfully delivered the following services for our end
          clients in the Utilities and Resources sectors.
        </p>
        <a class="text-[#de5654] " href="#">
          Download our Capability Statement
        </a>
      </section>
      <section className="flex  justify-center items-start mt-8 py-10 px-4">
        <div className="w-full max-w-7xl mx-auto">
          <div className={` flex md:flex-row flex-col`}>
            {categoryContents.map((row, index) => {
              return (
                <div key={index} className="  flex flex-col mx-3 ">
                  {row.map((col, index) => {
                    return !col.isOffSection ? (
                      <div key={index} className={` relative w-full my-3 `}>
                        <img
                          src={col.image}
                          alt="Image 1"
                          className="w-full  h-auto grow transition duration-300 ease-in transform hover:scale-[1.03]  "
                        />
                        <button
                          className=" rounded text-sm h-10 absolute bottom-10 left-1/2 transform
                 -translate-x-1/2 bg-white text-gray-700 hover:bg-red-500/80 
                  hover:text-white transition-colors duration-300 ease-in hover:transition-delay-300 px-10 py-2  overflow-wrap"
                          onClick={() => handleButtonClick("Image 1")}
                        >
                          <a className=" uppercase" href="#">
                            {col.name}
                          </a>
                        </button>
                      </div>
                    ) : (
                      <div
                        key={index}
                        className={` w-full my-3 bg-[rgb(245,233,233)] rounded flex flex-col py-10 px-10 items-center justify-center  h-full  `}
                      >
                        <h1 className="text-[#7a3432] text-center  font-semibold  text-4xl">
                          Careers <br />
                        </h1>
                        <p className=" text-gray-500 text-center mt-3">
                          The team welcomes applications from capable,
                          open-minded and professional candidates for the roles
                          below
                        </p>
                        <button className=" uppercase mt-8 rounded-full hover:bg-[#7a3432] duration-500 bg-[#bd6961] p-3 px-12 text-white">
                          work with us
                        </button>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
